import "core-js/modules/web.dom-collections.iterator.js";

function memoize(fn) {
  const cache = {};
  return (arg, ...args) => {
    if (cache[arg] === undefined) cache[arg] = fn(arg, ...args);
    return cache[arg];
  };
}

function createShouldForwardProp(props) {
  return memoize((prop, isPropValid) => isPropValid(prop) && !props.includes(prop));
}

export { createShouldForwardProp };